var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLoginlayoutSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#paint0_diamond_63_1377)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1862.5 859C1882.46 859 1901.76 861.861 1920 867.195V1080H1658.66C1658.22 1074.56 1658 1069.05 1658 1063.5C1658 950.558 1749.56 859 1862.5 859Z",
    fill: "url(#paint1_linear_63_1377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.204 0C804.898 95.3433 715 254.173 715 434C715 725.606 951.394 962 1243 962C1534.61 962 1771 725.606 1771 434C1771 254.173 1681.1 95.3433 1543.8 0H942.204ZM1453 434C1453 549.98 1358.98 644 1243 644C1127.02 644 1033 549.98 1033 434C1033 318.02 1127.02 224 1243 224C1358.98 224 1453 318.02 1453 434Z",
    fill: "url(#paint2_linear_63_1377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_63_1377",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1713 -54.9999) rotate(149.692) scale(1911.22 3397.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19EBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685231,
    stopColor: "#3D53D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#002A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_1377",
    x1: 1862.5,
    y1: 859,
    x2: 1862.5,
    y2: 1268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#20F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_1377",
    x1: 1243,
    y1: -94,
    x2: 1243,
    y2: 962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#0A316F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#485BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28DBF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLoginlayoutSignup);
export default __webpack_public_path__ + "static/media/background-loginlayout-signup.2eadbd40aa1bcc7d18669fab9ef17e39.svg";
export { ForwardRef as ReactComponent };